import React from 'react'
// components
import UploadImage from '../shared/UploadImage'
import { ReduxInput } from 'components/FormElements'

const ImageFields: React.FC = () => {
  return (
    <>
      <UploadImage name='image' />
      <ReduxInput name='height' label='Height (px)' type='number' />
    </>
  )
}

export default ImageFields
